export default function TugOfWarIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M4 52 H60" stroke="#3B434F" strokeWidth="3" strokeLinecap="round" />
      <path d="M14 34 Q32 38 50 34" stroke="#E7ECF3" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M30 35 V22 l8 3 l-8 3" fill="#E7ECF3" stroke="#E7ECF3" strokeWidth="2" strokeLinejoin="round" />
      <circle cx="9" cy="20" r="5" fill="#2F8BFF" />
      <path d="M10 26 L6 40 L2 51 M6 40 L12 51 M9 30 L15 34" stroke="#2F8BFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="55" cy="20" r="5" fill="#FF8A1F" />
      <path d="M54 26 L58 40 L62 51 M58 40 L52 51 M55 30 L49 34" stroke="#FF8A1F" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}
